import React from "react"
import { OrderAttributes, OrderShipping, ShippingFee } from "lib/types/generated/graphql-types"
import { Container, Row } from "./ShippingComponents.styled"
import ListEntry from "../Ui/ListEntry"
import { Maybe } from "@graphql-tools/utils"

type Props = {
  orderShipping: OrderShipping
  shippingFees: ShippingFee[]
  totalWeight: number
  attributes: Maybe<OrderAttributes> | undefined
}

const ShippingDetails = ({ orderShipping, shippingFees, totalWeight, attributes }: Props) => {
  return (
    <Container>
      {shippingFees.map((fee) => (
        <React.Fragment key={fee.id}>
          <Row $templateColumns={"2fr 2fr 1fr"}>
            <ListEntry label={"Shipping provider"} value={orderShipping.providerName} />
            <ListEntry label={"Shipping method"} value={fee.name ?? ""} />
            <ListEntry label={"Total weight"} value={`${totalWeight} gr`} />
          </Row>
          <Row $templateColumns={"1fr 1fr"}>
          </Row>
        </React.Fragment>
      ))}
      {attributes?.merchantReference1 && (
        <ListEntry label={"Merchant reference 1"} value={attributes.merchantReference1} />
      )}
      {attributes?.merchantReference2 && (
        <ListEntry label={"Merchant reference 2"} value={attributes.merchantReference2} />
      )}
    </Container>
  )
}

export default ShippingDetails
